export default "__VITE_ASSET__578afb1a__"